import { makeStyles } from '@material-ui/core';
import { globalStore } from 'api';
import { asCurrency, CollapsableSection, Column, Columns, div, FormInput, FormValue } from 'lqx-react';
import * as React from 'react';
import { Payment } from 'src/app/pages/inmatch/api';

export const Delta = ({ payment, right } : {
    payment: Payment,
    right?: React.ReactNode
}) => {
    const { deductables, delta, defaultFees, currency } = payment;
    
    const classes = useStyles({ payment });
    const inputClasses = useInputStyles();
    const negativeInputClasses = useNegativeInputStyles();

    return (
        <CollapsableSection
            title="Delta"
            info={
                payment.matches.length ?
                    <FormValue className={ classes.redLabel }>
                        { asCurrency(delta, currency) }
                    </FormValue>
                :
                    "-"
            }
            right={
                <>
                    { right }
                </>
            }
            notExpanded
        >
            <Columns>
                <Column>
                    <FormInput label="Processing Fees" positive number classes={ negativeInputClasses }
                        $value={ deductables.$.processingFees } />

                    <FormInput label="Marketing discount" positive number classes={ negativeInputClasses }
                        $value={ deductables.$.marketingDiscount } />
                    <FormInput label="Credit Note #"
                        $value={ deductables.creditNote.$.number }
                    />
                    <FormInput label="Credit Note Amount Applied" positive number classes={ negativeInputClasses }
                        disabled={!deductables.creditNote.number}
                        $value={ deductables.creditNote.$.amountApplied }
                    />
                </Column>
                <Column>
                    <FormInput label="Amount send to payor" positive number classes={ inputClasses }
                        $value={ deductables.$.overpaymentSendToPayor } /> 
                    <FormInput label="Amount Settle off Platform" positive number classes={ inputClasses }
                        $value={ deductables.$.amountSettleOffPlatform } /> 
                    <FormInput label="Remaining Amount" positive number classes={ inputClasses } $value={ deductables.$.overpayment } />
                    <FormInput label="Final Cash Applied" positive number
                        classes={ inputClasses }
                        value={ asCurrency( payment.finalCashApplied, currency ) } />
                </Column>
            </Columns>
        </CollapsableSection>
    );
};

const Space = div({
    minWidth: 12
})

const useStyles = makeStyles({
    redLabel: {
        color: ({ payment } : any ) => payment.delta < 0 ? 'red' : 'black',
        flex: 0
    }
});

const inputStyles = {
    input: {
        width: 'unset !important'
    }
}

const useInputStyles = makeStyles({
    ...inputStyles
});

const useNegativeInputStyles = makeStyles({
    input: {
        ...inputStyles.input,
        color: 'red !important'
    }
});
